import { ImageFragment } from '@/graphql/fragments/image';
import { gql } from '@apollo/client';

export const QUERY_MEDITATION_DETAIL_PAGE = gql`
  query meditationDetailPage {
    meditationDetailPage {
      data {
        attributes {
          startBtn
          pauseBtn
          stopBtn
          youMayAlsoLikeTitle
          moreBtn
          goToTheMeditationBtn
          thankYou
        }
      }
    }
  }
`;

export const QUERY_MEDITATION_PAGE = gql`
  query meditationPage {
    meditationPage {
      data {
        attributes {
          header {
            image {
              data {
                ...ImageFragment
              }
            }
            title
            description
          }
          moreBtn
          goToTheMeditationBtn
          sectionLabel
        }
      }
    }
  }
  ${ImageFragment}
`;

export const QUERY_MEDITATIONS = gql`
  query meditations($page: Int) {
    meditations(pagination: { page: $page, pageSize: 5 }, sort: "publicationDate:desc") {
      data {
        id
        attributes {
          title
          subHeader
          slug
          duration
          briefDescription
          type
          mindful_exercise_type {
            data {
              attributes {
                name
              }
            }
          }
        }
      }
      meta {
        pagination {
          total
          pageCount
          page
        }
      }
    }
  }
`;

export const QUERY_MEDITATION = gql`
  query meditation($slug: [String]) {
    meditations(pagination: { limit: 1 }, sort: "publicationDate:desc", filters: { slug: { in: $slug } }) {
      data {
        id
        attributes {
          title
          subHeader
          slug
          briefDescription
          type
          presentedBy
          mindful_exercise_type {
            data {
              attributes {
                name
              }
            }
          }
          themes {
            data {
              attributes {
                theme
                topic {
                  data {
                    attributes {
                      topic
                    }
                  }
                }
              }
            }
          }
          audio {
            transcription
            audio {
              data {
                attributes {
                  url
                }
              }
            }
          }
          video {
            data {
              attributes {
                url
              }
            }
          }
          relatedContent {
            data {
              attributes {
                title
                duration
                slug
                briefDescription
                type
                mindful_exercise_type {
                  data {
                    attributes {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
